<div class="card-header-mini">
  <h3 class="card-title">{{widgetData.title}}</h3>
  <a *ngIf="widgetData.allLinkUrl" href="{{widgetData.allLinkUrl}}" target="{{widgetData.allLinkTarget}}" class="more-link">{{widgetData.allLinkText}}</a>
</div>

<div class="carousel-wrap carousel-wrap-with-navigation" *ngIf="!isLoading && events && events.length && !isServerError">
  <swiper-container 
    #carousel
    pagination="true" 
    pagination-clickable="true" 
    [breakpoints]="breakpoints" 
    class="carousel">
    <swiper-slide *ngFor="let event of events">
      <app-close-event-item [event]="event" [addToDiaryBtnText]="widgetData.btnAddToDiaryText" [atTimeText]="widgetData.atTimeText" [upToText]="widgetData.upToText"/>
    </swiper-slide>
  </swiper-container>

  <div>
    <button *ngIf="events.length > 1" class="button-prev" [ngClass]="{ locked: lockPrev }" (click)="prevSlide()">
      <mat-icon [svgIcon]="'prev-2'" class="square-icon button-icon"></mat-icon>
    </button>
    <button *ngIf="events.length > 1" class="button-next" [ngClass]="{ locked: lockNext }" (click)="nextSlide()">
      <mat-icon [svgIcon]="'next-2'" class="square-icon button-icon"></mat-icon>
    </button>
  </div>
</div>
<div class="carousel-wrap carousel-wrap-with-navigation" *ngIf="isLoading && !isServerError">
  <div class="carousel">
    <app-close-event-item [event]="{}" [isLoading]="true" [addToDiaryBtnText]="widgetData.btnAddToDiaryText"/>
  </div>
</div>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>